import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { BENEFITS } from "../../lib/data";
import { Reveal, Overline } from "../Reveal";

export const Testimonials = () => (
  <section className="bg-[#F9F9F8] text-[#050505] pt-[120px] pb-16 md:py-32 px-6" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-3xl mb-16">
        <Reveal><Overline>Korzyści</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.02] font-semibold">
            Co może zyskać <span className="font-serif-italic font-normal">Twoja firma?</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {BENEFITS.map((b, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08}>
            <motion.div whileHover={{ y: -4 }} className="h-full bg-white border border-black/5 rounded-2xl p-8 flex items-start gap-4" data-testid={`benefit-${i}`}>
              <span className="h-10 w-10 shrink-0 rounded-xl bg-[#050505] text-white flex items-center justify-center"><Check size={18} strokeWidth={2} /></span>
              <p className="text-lg leading-relaxed text-[#1a1a1a] pt-1.5">{b}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
